import { FC, useEffect, useId, useState } from 'react';
import Card from '../Card/Card';
import Icon from '../Icons/Icon';
import styles from './Accordion.module.css';
import { AccordionProps } from './Accordion.types';

const Accordion: FC<AccordionProps> = ({ title, children, isOpen = false, onOpen }) => {
  const [open, setOpen] = useState(isOpen);
  const id = useId();

  useEffect(() => {
    if (isOpen !== undefined) setOpen(isOpen);
  }, [isOpen]);

  const handleClick = () => {
    if (onOpen !== undefined) {
      onOpen();
    } else {
      setOpen((prevState) => !prevState);
    }
  };

  return (
    <Card>
      <div className={styles.titleRow}>
        <div className={styles.title}>{title}</div>
        <Icon iconName={open ? 'ChevronUp' : 'ChevronDown'} onClick={handleClick} id={id} />
      </div>
      <div style={{ display: open ? 'block' : 'none' }} className={styles.content}>
        {children}
      </div>
    </Card>
  );
};

export default Accordion;
